/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_ActionsInputs */

const en_colleague_actions = /** @type {(inputs: Colleague_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const ja_colleague_actions = /** @type {(inputs: Colleague_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクション`)
};

const fr_colleague_actions = /** @type {(inputs: Colleague_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const de_colleague_actions = /** @type {(inputs: Colleague_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Colleague_ActionsInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_actions = /** @type {((inputs?: Colleague_ActionsInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_ActionsInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_actions(inputs)
	if (locale === "ja") return ja_colleague_actions(inputs)
	if (locale === "fr") return fr_colleague_actions(inputs)
	return de_colleague_actions(inputs)
});